/*
Model defined for Maintaining Permission Responses. It can also be used for transferring model
*/
export class RateAlertModel {
    userID: string;
    currencyCode: string;
    upperLimit: string;
    lowerLimit: string;
    partnerID: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/rates/RateAlertModel.ts